import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { Sociedad } from '../model/sociedad';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from '../shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-sociedades',
  templateUrl: './sociedades.component.html',
  styleUrls: ['./sociedades.component.css']
})
export class SociedadesComponent implements OnInit {
  sociedad: string;
  sociedades: Sociedad[] = [];
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;
  loading: boolean = true;
  id_sociedad: string = '';

  constructor(
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private changeDetectorRefs: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.loading = true;
    let language = this.auth.getLanguage();
    if (!language) language = 'es';
    this.translate.setDefaultLang(language);

    this.sociedad = this.auth.getNameSociedad();

    this.apiService.searchSociedades().subscribe({
      next: (sociedades) => {
        if (sociedades.code === 200 && sociedades.success) {
          this.sociedades = sociedades.data;
        }
        this.loading = false;
      },
      error: (err) => {
        this.sociedades = [];
        this.loading = false;
      }
    });

    this.validatingForm = new FormGroup({
      signupFormModalId: new FormControl('', [
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalWeb: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^(https?:\/\/)?[\w\-]+(\.[\w\-]+)+[/#?]?.*$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        Validators.pattern(/^(?!.*(<|>|script|on\w+=|javascript:|data:text\/html|base64)).*$/i),
        CustomValidators.secureInput
      ])
    });
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalWeb() {
    return this.validatingForm.get('signupFormModalWeb');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  showSociedad(sociedad: Sociedad) {
    this.IsHiddenForm = true;
    this.id_sociedad = sociedad.id_sociedad;

    this.validatingForm.patchValue({
      signupFormModalId: sociedad.id_sociedad,
      signupFormModalName: sociedad.n_sociedad,
      signupFormModalWeb: sociedad.web,
      contactFormModalMessage: sociedad.comentario
    });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  updateSociedad(id_sociedad: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    this.apiService.updateSociedad(
      id_sociedad,
      this.signupFormModalName?.value,
      this.signupFormModalWeb?.value,
      this.contactFormModalMessage?.value
    ).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_280'), this.translate.instant('texto_282'));
        } else {
          this.toastr.error(this.translate.instant('texto_281'), this.translate.instant('texto_282'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['dashboard/layout/sociedades']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_281'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_281'), this.translate.instant('texto_813'));
        }
      });
  }

  deleteSociedad(id_sociedad: string) {
    this.apiService.countComplaintByIdSociedad(id_sociedad).subscribe(
      res => {
        if (res.success && res.data.count === 0) {
          this.apiService.deleteSociedad(id_sociedad).subscribe(
            res => {
              if ((res as any).success === true) {
                this.toastr.success(this.translate.instant('texto_276'), this.translate.instant('texto_279'));
              } else {
                this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_279'));
              }
              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['dashboard/layout/sociedades']);
              });
            },
            err => {
              if (err.status === 409) {
                this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_813'));
              } else {
                this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_813'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_278'), this.translate.instant('texto_277'));
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['dashboard/layout/sociedades']);
          });
        }
      },
      err => {
      this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_813'));
    }
    );
  }
}
